import React from 'react';
import classnames from 'classnames/bind';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { ADJUSTMENT_METHODS } from '../../hooks/useAdjustmentMethodOptions';
import styles from '../../bidAdjustmentMethod.module.scss';

const classNameBuilder = classnames.bind(styles);

const descriptionMessageIdPrefix = 'campaign.editor.bid.adjustment.method.option.description';
const adjustmentMethodDescriptions = {
    [ADJUSTMENT_METHODS.BID_CONTROL]: `${descriptionMessageIdPrefix}.${ADJUSTMENT_METHODS.BID_CONTROL}`,
    [ADJUSTMENT_METHODS.BID_MODIFIER]: `${descriptionMessageIdPrefix}.${ADJUSTMENT_METHODS.BID_MODIFIER}`,
};

export const BidAdjustmentMethodItem = ({ data: { value, label }, selectProps: { menuIsOpen } }) => {
    const getDescriptionMessageId = value => {
        if (!value) {
            return null;
        }

        return adjustmentMethodDescriptions[value] || `${descriptionMessageIdPrefix}.default`;
    };

    const descriptionMessageId = getDescriptionMessageId(value);

    return (
        <div className={styles['bid-item']}>
            <div>{label}</div>
            <div className={classNameBuilder('description', 'description-item')}>
                {menuIsOpen && descriptionMessageId && <FormattedMessage id={descriptionMessageId} />}
            </div>
        </div>
    );
};
